var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.425,
    height: 30.666,
    viewBox: "0 0 112.425 30.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,163.931V150.949H2.752v12.982Z",
    transform: "translate(0 -150.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.021 0.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.736,157.316a6.394,6.394,0,0,1-1.825,4.91,7.441,7.441,0,0,1-5.27,1.7H5.965V150.949h4.076a6.865,6.865,0,0,1,4.937,1.679A6.174,6.174,0,0,1,16.736,157.316Zm-2.859.071q0-4.182-3.694-4.182H8.717v8.453H9.9Q13.876,161.658,13.876,157.387Z",
    transform: "translate(-5.965 -150.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.482 0.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.778,163.931H19.3V150.949h7.476V153.2H22.054v2.849h4.395v2.256H22.054v3.348h4.724Z",
    transform: "translate(-19.302 -150.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.18,157.425a7.045,7.045,0,0,1-1.6,4.954A5.926,5.926,0,0,1,35,164.111a5.922,5.922,0,0,1-4.581-1.732,7.068,7.068,0,0,1-1.6-4.972,6.975,6.975,0,0,1,1.6-4.951,5.993,5.993,0,0,1,4.594-1.709A5.911,5.911,0,0,1,39.6,152.47,7.065,7.065,0,0,1,41.18,157.425Zm-9.475,0a5.426,5.426,0,0,0,.826,3.276A2.891,2.891,0,0,0,35,161.8q3.294,0,3.294-4.376t-3.277-4.388a2.91,2.91,0,0,0-2.477,1.106A5.4,5.4,0,0,0,31.706,157.425Z",
    transform: "translate(-28.82 -150.747)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.139 0.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.731,163.931V150.949h2.752v10.709h5.266v2.273Z",
    transform: "translate(-43.731 -150.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.836)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.7,157.425a7.045,7.045,0,0,1-1.6,4.954,5.925,5.925,0,0,1-4.582,1.732,5.928,5.928,0,0,1-4.582-1.732,7.072,7.072,0,0,1-1.6-4.972,6.979,6.979,0,0,1,1.6-4.951,6,6,0,0,1,4.6-1.709,5.91,5.91,0,0,1,4.577,1.723A7.06,7.06,0,0,1,65.7,157.425Zm-9.475,0a5.419,5.419,0,0,0,.827,3.276,2.888,2.888,0,0,0,2.468,1.1q3.294,0,3.294-4.376t-3.276-4.388a2.909,2.909,0,0,0-2.477,1.106A5.393,5.393,0,0,0,56.224,157.425Z",
    transform: "translate(-53.338 -150.747)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.31 0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.183,156.642h5.151v6.731a14.451,14.451,0,0,1-2.358.572,15.419,15.419,0,0,1-2.26.165,5.717,5.717,0,0,1-4.489-1.727,7.188,7.188,0,0,1-1.549-4.959,6.542,6.542,0,0,1,1.8-4.9,6.827,6.827,0,0,1,4.985-1.758,9.64,9.64,0,0,1,3.854.8l-.914,2.2a6.533,6.533,0,0,0-2.956-.711,3.65,3.65,0,0,0-2.859,1.2,4.648,4.648,0,0,0-1.075,3.223,5.176,5.176,0,0,0,.866,3.228,3,3,0,0,0,2.517,1.114,8.921,8.921,0,0,0,1.749-.178v-2.708h-2.46Z",
    transform: "translate(-67.678 -150.764)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.76)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M81,136.283v30.666H96.2L94,164.255h-.2a5.925,5.925,0,0,1-4.582-1.732,7.067,7.067,0,0,1-1.6-4.972,6.975,6.975,0,0,1,1.6-4.951,6,6,0,0,1,4.594-1.709,5.912,5.912,0,0,1,4.578,1.723,7.065,7.065,0,0,1,1.585,4.955,8.206,8.206,0,0,1-.813,3.84,4.952,4.952,0,0,1-2.385,2.269l2.93,3.271h11.959V136.283Zm4.135,27.794H82.431V154.15h2.708Zm-.244-11.512a1.546,1.546,0,0,1-1.105.351q-1.473,0-1.474-1.332t1.474-1.323q1.473,0,1.474,1.323A1.285,1.285,0,0,1,84.895,152.565Z",
    transform: "translate(-81.004 -136.283)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.499 16.899)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M93.727,153.026a2.908,2.908,0,0,0-2.477,1.105,6.89,6.89,0,0,0-.009,6.558,2.891,2.891,0,0,0,2.469,1.1q3.294,0,3.293-4.378T93.727,153.026Z",
    transform: "translate(-90.415 -153.026)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.32b67a68517022f4e8bc09d52f1c8627.svg";
export { ForwardRef as ReactComponent };